/**
 * SNS Links Panel Listener
 *
 * Listener layer: registers event listeners only.
 */

import type { SNSLinksPanelForm } from "./sns-links-panel-form";
import type { SNSLinksPanelHandler } from "./sns-links-panel-handler";

export class SNSLinksPanelListener {
    private readonly form: SNSLinksPanelForm;
    private readonly handler: SNSLinksPanelHandler;

    /** Store listener dependencies for the panel. */
    public constructor(form: SNSLinksPanelForm, handler: SNSLinksPanelHandler) {
        this.form = form;
        this.handler = handler;
    }

    /**
     * Listener layer: registers event listeners only.
     */
    public register(): void {
        const panelRoot = this.form.getRoot();
        const openButton = this.form.getOpenButton();
        const editButton = this.form.getEditButton();
        const closeButton = this.form.getCloseButton();
        const saveButton = this.form.getSaveButton();
        const form = this.form.getClosestForm();

        panelRoot.addEventListener("click", this.handler.handleAddTileClick.bind(this.handler));
        panelRoot.addEventListener("click", this.handler.handleTileRemoveClick.bind(this.handler));

        if (form) {
            form.addEventListener("submit", this.handler.handleFormSubmit.bind(this.handler));
        }

        if (openButton) {
            openButton.addEventListener("click", this.handler.handleOpenClick.bind(this.handler));
        }

        if (editButton) {
            editButton.addEventListener("click", this.handler.handleEditClick.bind(this.handler));
        }

        if (closeButton) {
            closeButton.addEventListener("click", this.handler.handleCloseClick.bind(this.handler));
        }

        if (saveButton) {
            saveButton.addEventListener("click", this.handler.handleCloseClick.bind(this.handler));
        }
    }
}
